export default __webpack_public_path__ + "static/media/patient_referral.7fc52147.jpg";